import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { withFormikField, getFormikError } from 'utils/formik';
import { Field } from '@ontruck/orc';
import { injectIntl } from 'react-intl';
const StyledField = styled(Field)`
  width: 100%;
`;

const LoadWeight = ({ field, form, intl, ...props }) => {
  const t = intl.messages.modules.shipper_order.form.load_section;
  const { value, name } = field;
  const { setFieldValue } = form;
  return (
    <StyledField
      {...props}
      label={t.load_weight}
      value={value || ''}
      error={false}
      invalid={!!getFormikError({ field, form })}
      onChange={(e, { value }) => {
        setFieldValue(name, value);
      }}
    />
  );
};

LoadWeight.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
};

LoadWeight.defaultProps = {
  field: 'load',
};

export default withFormikField(injectIntl(LoadWeight));
